export const DESKTOP_ITEM_COUNT = 40;
export const MOBILE_ITEM_COUNT = 24;
